import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import JugClass from '@/assets/Projects/ClimbingHoldClassifierPhotos/JugClass.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClimbingHoldClassifier',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'Climbing Hold Classifier',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Solo Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "January 2026 - Present")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " 5-stage Computer Vision pipeline for classifying climbing holds in images into 7 classes "),
          _createElementVNode("span", { class: "block" }, " Utilizes YOLO11n object detection, CLAHE normalization, SAM segmentation, ResNet-18 CNN feature extraction, & RBF-kernel SVM classification "),
          _createElementVNode("span", { class: "block" }, " Collected & labeled 2000 climbing hold images from Notre Dame's climbing wall for training, validating, & testing "),
          _createElementVNode("span", { class: "block" }, " Achieved 80.2% test accuracy after comparing 8 pipeline architectures "),
          _createElementVNode("a", {
            href: "https://github.com/cgreen2048/Climbing-Hold-Classifier",
            target: "_blank",
            class: "photo-link"
          }, [
            _createTextVNode(" View my "),
            _createElementVNode("span", { class: "link-in-text" }, " Github Repo ")
          ])
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[50%] h-auto rounded-lg cursor-pointer",
            src: _unref(JugClass),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(JugClass), 'Jug Class Screenshot', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})